module.exports = __webpack_public_path__ + "static/hero-20861558dd7a178dbdd8891b8b1bf020.jpg";